/* eslint-disable no-unused-vars */
import { Suspense, lazy, useEffect } from 'react';
import { Navigate, Outlet, useNavigate, useRoutes } from 'react-router-dom';
import AuthGuard from './components/AuthGuard';
import PermissionGuard from './components/PermissionGuard';
import BlogLayout from './components/blog/BlogLayout';
import CampaignLearner from './components/campagne/CampaignLearner';
import CampaignInfo from './components/campagne/CampaignInfo';
// import BrowseLayout from './components/BrowseLayout';
import DashboardLayout from './components/dashboard/DashboardLayout';
import { SessionStats } from './components/dashboard/session';
// import UserGeneralSettings from './components/dashboard/users/UserGeneralSettings';
import DocsLayout from './components/docs/DocsLayout';
import GuestGuard from './components/GuestGuard';
import LoadingScreen from './components/LoadingScreen';
import MainLayout from './components/MainLayout';
import Form from './forme_contact';
import AccountAdmin from './pages/dashboard/AccountAdmin';
import Analysis from './pages/dashboard/Analysis';
import Campagnes from './pages/dashboard/Campagnes';
import Reminders from './pages/dashboard/Reminders';
// import CampaignCustomerDetails from './pages/dashboard/CampaignCustomerDetails';
// import CampaignList from './pages/dashboard/CampaignList';
import UsersList from './pages/dashboard/UsersList';
import RelaunchInfo from './components/dashboard/relaunch/RelaunchInfo';
import RelaunchCustomerDetails from './pages/dashboard/RelaunchCustomerDetails';
import Shift from './pages/dashboard/Shift';
import CustomerNewProspects from './components/dashboard/customer/CustomerNewProspects';
import SessionFormationList from './components/dashboard/session/SessionFormationList';
import CampaignReinjectionCustomerDetails from './pages/dashboard/CampaignReinjectionCustomerDetails';
import CustomReports from './pages/dashboard/custom-repports/CustomReports';
import CustomReportCreate from './pages/dashboard/custom-repports/CustomReportCreate';
import CustomReportDetails from './pages/dashboard/custom-repports/CustomReportDetails';
import Logs from './pages/dashboard/Logs';
import CustomReportFullDetails from './pages/dashboard/custom-repports/components/CustomReportFullDetails';
import Partners from './pages/dashboard/Partners';
import useAuth from './hooks/useAuth';
import QualityPage from './pages/dashboard/QualityPage';
import Qualiopi from './pages/dashboard/Qualiopi';
import { DrawerProvider } from './contexts/DrawerContext';
import Imports from './pages/dashboard/Imports';
import FormationsSatisfaction from './pages/dashboard/formationSatisfaction/FormationsSatisfaction';
import FormationsPerformance from './pages/dashboard/formationPerformance/FormationPerformance';
import QuestionnaireFormation from './pages/dashboard/QuestionnaireFormation';
import QuestionnaireSatisfaction from './pages/dashboard/QuestionnaireSatisfaction';
import QuestionnaireFormateurs from './pages/dashboard/QuestionnaireFormateurs';
import ComptesRendus from './pages/dashboard/ComptesRendus';
import ActionPlanFormation from './pages/dashboard/ActionPlanFormation';
import ActionPlansOuverts from './pages/dashboard/ActionPlansOuverts';
import QuestionnaireProgression from './pages/dashboard/QuestionnaireProgression';
import QuestionnaireDetails from './pages/dashboard/QuestionnaireDetails';
import NewImport from './pages/dashboard/imports-new/NewImport';
import CSVImportPage from './pages/dashboard/imports-new/CSVImportPage';
import ImportHistoryPage from './pages/dashboard/imports-new/ImportHistoryPage';
import EmailNotificationPage from './pages/dashboard/EmailNotificationPage';
import EmailTemplateCreate from './components/EmailNotifications/EmailTemplateCreate';
import ScheduledNotificationsPage from './pages/dashboard/ScheduledNotificationsPage';
import VersionNotesPage from './pages/dashboard/VersionNotesPage';
import QuestionnairePublic from './pages/QuestionnairePublic';
import EvaluationLieuPublic from './pages/EvaluationLieuPublic';
import AgreementSignPublic from './pages/AgreementSignPublic';
import VisualisationGlobale from './pages/dashboard/VisualisationGlobale';

const Loadable = (Component) => (props) => (
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
);

// Browse pages

/* const Browse = Loadable(lazy(() => import('./pages/browse/Browse')));
const BrowseButtons = Loadable(lazy(() => import('./pages/browse/BrowseButtons')));
const BrowseCharts = Loadable(lazy(() => import('./pages/browse/BrowseCharts')));
const BrowseColors = Loadable(lazy(() => import('./pages/browse/BrowseColors')));
const BrowseDetailLists = Loadable(lazy(() => import('./pages/browse/BrowseDetailLists')));
const BrowseForms = Loadable(lazy(() => import('./pages/browse/BrowseForms')));
const BrowseGridLists = Loadable(lazy(() => import('./pages/browse/BrowseGridLists')));
const BrowseGroupedLists = Loadable(lazy(() => import('./pages/browse/BrowseGroupedLists')));
const BrowseInputs = Loadable(lazy(() => import('./pages/browse/BrowseInputs')));
const BrowseModals = Loadable(lazy(() => import('./pages/browse/BrowseModals')));
const BrowseQuickStats = Loadable(lazy(() => import('./pages/browse/BrowseQuickStats')));
const BrowseTables = Loadable(lazy(() => import('./pages/browse/BrowseTables')));
const BrowseTypography = Loadable(lazy(() => import('./pages/browse/BrowseTypography'))); */

// Authentication pages
const Formulaire = Loadable(lazy(() => Form));
const Login = Loadable(lazy(() => import('./pages/authentication/Login')));
const PasswordRecovery = Loadable(lazy(() => import('./pages/authentication/PasswordRecovery')));
const PasswordReset = Loadable(lazy(() => import('./pages/authentication/PasswordReset')));
const Register = Loadable(lazy(() => import('./pages/authentication/Register')));
const VerifyCode = Loadable(lazy(() => import('./pages/authentication/VerifyCode')));

// Espace formateur — chargé à la demande : le bundle du CRM n'en porte rien.
const FormateurLayout = Loadable(lazy(() => import('./components/formateur/FormateurLayout')));
const FormateurLogin = Loadable(lazy(() => import('./pages/formateur/FormateurLogin')));
const FormateurInvitation = Loadable(lazy(() => import('./pages/formateur/FormateurInvitation')));
const FormateurSessions = Loadable(lazy(() => import('./pages/formateur/FormateurSessions')));
const FormateurProfile = Loadable(lazy(() => import('./pages/formateur/FormateurProfile')));
const FormateurDocuments = Loadable(lazy(() => import('./pages/formateur/FormateurDocuments')));
const FormateurCompetences = Loadable(lazy(() => import('./pages/formateur/FormateurCompetences')));
const FormateurVeille = Loadable(lazy(() => import('./pages/formateur/FormateurVeille')));
const FormateurSessionDetail = Loadable(lazy(() => import('./pages/formateur/FormateurSessionDetail')));
const FormateurPlanning = Loadable(lazy(() => import('./pages/formateur/FormateurPlanning')));
const FormateurFinances = Loadable(lazy(() => import('./pages/formateur/FormateurFinances')));
const FormateurDashboard = Loadable(lazy(() => import('./pages/formateur/FormateurDashboard')));
const FormateurIncidents = Loadable(lazy(() => import('./pages/formateur/FormateurIncidents')));
const FormateurSignalements = Loadable(lazy(() => import('./pages/formateur/FormateurSignalements')));

// Blog pages

const BlogPostCreate = Loadable(lazy(() => import('./pages/blog/BlogPostCreate')));
const BlogPostDetails = Loadable(lazy(() => import('./pages/blog/BlogPostDetails')));
const BlogPostList = Loadable(lazy(() => import('./pages/blog/BlogPostList')));

// Dashboard pages

const Account = Loadable(lazy(() => import('./pages/dashboard/Account')));
const Analytics = Loadable(lazy(() => import('./pages/dashboard/Analytics')));
const Calendar = Loadable(lazy(() => import('./pages/dashboard/Calendar')));
const Presence = Loadable(lazy(() => import('./pages/dashboard/Presence')));
const Chat = Loadable(lazy(() => import('./pages/dashboard/Chat')));
const CustomerDetails = Loadable(lazy(() => import('./pages/dashboard/CustomerDetails')));
const EmailSettings = Loadable(lazy(() => import('./pages/dashboard/EmailSettings')));
const CustomerCreate = Loadable(lazy(() => import('./pages/dashboard/CustomerCreate')));
const CustomerList = Loadable(lazy(() => import('./pages/dashboard/CustomerList')));
const Intervenants = Loadable(lazy(() => import('./pages/dashboard/Intervenants')));
const IntervenantDetails = Loadable(lazy(() => import('./pages/dashboard/IntervenantDetails')));
const LieuxFormation = Loadable(lazy(() => import('./pages/dashboard/LieuxFormation')));
const LieuFiche = Loadable(lazy(() => import('./pages/dashboard/LieuFiche')));
const Finance = Loadable(lazy(() => import('./pages/dashboard/Finance')));
const InvoiceDetails = Loadable(lazy(() => import('./pages/dashboard/InvoiceDetails')));
const InvoiceList = Loadable(lazy(() => import('./pages/dashboard/InvoiceList')));
const Kanban = Loadable(lazy(() => import('./pages/dashboard/Kanban')));
const Mail = Loadable(lazy(() => import('./pages/dashboard/Mail')));
const OrderDetails = Loadable(lazy(() => import('./pages/dashboard/OrderDetails')));
const OrderList = Loadable(lazy(() => import('./pages/dashboard/OrderList')));
const Overview = Loadable(lazy(() => import('./pages/dashboard/Overview')));
const ProductCreate = Loadable(lazy(() => import('./pages/dashboard/ProductCreate')));
const ProductList = Loadable(lazy(() => import('./pages/dashboard/ProductList')));
const CampaignCustomerDetails = Loadable(lazy(() => import('./pages/dashboard/CampaignCustomerDetails')));

// Docs pages

const Docs = Loadable(lazy(() => import('./pages/Docs')));

// Error pages

const AuthorizationRequired = Loadable(lazy(() => import('./pages/AuthorizationRequired')));
const NotFound = Loadable(lazy(() => import('./pages/NotFound')));
const ServerError = Loadable(lazy(() => import('./pages/ServerError')));

// Formations pages

const Formations = Loadable(lazy(() => import('./pages/dashboard/Formations')));
const FormationDetails = Loadable(lazy(() => import('./pages/dashboard/FormationDetails')));
const FormationCreate = Loadable(lazy(() => import('./pages/dashboard/FormationCreate')));
const TasksTracking = Loadable(lazy(() => import('./pages/dashboard/TasksTracking')));
const Academie = Loadable(lazy(() => import('./pages/dashboard/Academie')));
const RhCollaborateurs = Loadable(lazy(() => import('./pages/dashboard/RhCollaborateurs')));
const RhConges = Loadable(lazy(() => import('./pages/dashboard/RhConges')));
const RhPointage = Loadable(lazy(() => import('./pages/dashboard/RhPointage')));
const RhEntretiens = Loadable(lazy(() => import('./pages/dashboard/RhEntretiens')));
const RhFormation = Loadable(lazy(() => import('./pages/dashboard/RhFormation')));
const RhSante = Loadable(lazy(() => import('./pages/dashboard/RhSante')));
const RhHandicap = Loadable(lazy(() => import('./pages/dashboard/RhHandicap')));
const RhDuerp = Loadable(lazy(() => import('./pages/dashboard/RhDuerp')));
const RhDashboard = Loadable(lazy(() => import('./pages/dashboard/RhDashboard')));
const RhConformite = Loadable(lazy(() => import('./pages/dashboard/RhConformite')));
const RhParametres = Loadable(lazy(() => import('./pages/dashboard/RhParametres')));
const RhRecrutement = Loadable(lazy(() => import('./pages/dashboard/RhRecrutement')));
const RhOnboarding = Loadable(lazy(() => import('./pages/dashboard/RhOnboarding')));
const RhCollaborateurFiche = Loadable(lazy(() => import('./pages/dashboard/RhCollaborateurFiche')));
const MailsTracking = Loadable(lazy(() => import('./pages/dashboard/MailsTracking')));
const LearnersTracking = Loadable(lazy(() => import('./pages/dashboard/LearnersTracking')));
const ReportsAndCancellationsTracking = Loadable(lazy(() => import('./pages/dashboard/ReportsAndCancellationsTracking')));

// Projects pages

const ProjectBrowse = Loadable(lazy(() => import('./pages/dashboard/ProjectBrowse')));
const ProjectCreate = Loadable(lazy(() => import('./pages/dashboard/ProjectCreate')));
const ProjectDetails = Loadable(lazy(() => import('./pages/dashboard/ProjectDetails')));

// Etablissements
const EtablissementCreate = Loadable(lazy(() => import('./pages/dashboard/EtablissementCreate')));
const EtablissementDetails = Loadable(lazy(() => import('./pages/dashboard/EtablissementDetails')));
const EtablissementList = Loadable(lazy(() => import('./pages/dashboard/EtablissementListe')));
const EtablissementEdit = Loadable(lazy(() => import('./pages/dashboard/EtablissementEdit')));

// Groupement
const GroupementCreate = Loadable(lazy(() => import('./pages/dashboard/GroupementCreate')));
const GroupementDetails = Loadable(lazy(() => import('./pages/dashboard/GroupementDetails')));
const GroupementList = Loadable(lazy(() => import('./pages/dashboard/GroupementListe')));
const GroupementEdit = Loadable(lazy(() => import('./pages/dashboard/GroupementEdit')));

// Etablissements
const SessionCreate = Loadable(lazy(() => import('./pages/dashboard/SessionCreate')));
const SessionDetails = Loadable(lazy(() => import('./pages/dashboard/SessionDetails')));
const SessionEdit = Loadable(lazy(() => import('./pages/dashboard/SessionEdit')));
const SessionCreatCustomer = Loadable(lazy(() => import('./pages/dashboard/SessionCreatCustomer')));
const RolesPermissions = Loadable(lazy(() => import('./pages/dashboard/RolesPermissions')));

// Anciennes règles en dur, utilisées par PermissionGuard seulement tant que
// l'API ne renvoie pas les permissions (déploiement front avant back).
const legacyTaskTracking = (u) => u.access_level === 0 || u.id_service === 4;
const legacyAdminOnly = (u) => u.access_level === 0 && u.id_service === 0;

// Social pages

const SocialFeed = Loadable(lazy(() => import('./pages/dashboard/SocialFeed')));
const SocialProfile = Loadable(lazy(() => import('./pages/dashboard/SocialProfile')));

// Campaign pages

const CampaignDetails = Loadable(lazy(() => import('./pages/dashboard/CampaignDetails')));
const CampaignCreate = Loadable(lazy(() => import('./components/dashboard/campaign/CampaignCreate')));

// Other pages

const Checkout = Loadable(lazy(() => import('./pages/Checkout')));
const Contact = Loadable(lazy(() => import('./pages/Contact')));
const Home = Loadable(lazy(() => import('./pages/Home')));
const Pricing = Loadable(lazy(() => import('./pages/Pricing')));

// Campagne
// const CampagneDetails = Loadable(lazy(() => import('./pages/dashboard/CampagneDetails')));
// const CampagneList = Loadable(lazy(() => import('./pages/dashboard/CampagneListe')));
// const CampagneStats = Loadable(lazy(() => import('./')
const AppRoutes = () => {
  const isAuthenticated = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      const enteredHostname = new URL(window.location.href).hostname;
      const enteredPathname = new URL(window.location.href).pathname;
      if (enteredPathname === '/') {
        // Effectue la redirection vers "/dashboard"
        navigate('/dashboard');
      }
    }
  }, [isAuthenticated, navigate]);
  const routes = [
    {
      path: '/',
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              <Login />
            </GuestGuard>
          )
        },
        {
          path: '/',
          element: <Login />
        },
        {
          path: 'password-recovery',
          element: <PasswordRecovery />
        },
        {
          path: 'password-reset',
          element: <PasswordReset />
        },
        {
          path: 'register',
          element: (
            <GuestGuard>
              <Register />
            </GuestGuard>
          )
        },
        {
          path: 'register-unguarded',
          element: <Register />
        },
        {
          path: 'verify-code',
          element: <VerifyCode />
        },
        {
          path: 'questionnaire-public/:id/:learnerId',
          element: <QuestionnairePublic />
        },
        {
          // Questionnaire de satisfaction du formateur : même page, mais le
          // répondant est un intervenant et la session est portée par l'URL.
          path: 'questionnaire-formateur/:id/:intervenantId/:sessionId',
          element: <QuestionnairePublic />
        },
        {
          path: 'sign-agreement/:token',
          element: <AgreementSignPublic />
        },
        {
          // Grille de conformite remplie par le lieu lui-meme : le jeton
          // recu par courriel tient lieu d'identite, il n'y a pas de compte.
          path: 'evaluation-lieu/:token',
          element: <EvaluationLieuPublic />
        }
      ]
    },
    // ESPACE FORMATEUR — branche indépendante de `dashboard`.
    //
    // Layout, jeton (clé `formateurToken`) et garde qui lui sont propres : ni
    // AuthGuard ni GuestGuard, qui appartiennent au CRM. Ajouter ou retirer un
    // écran ici ne touche à aucune route du CRM.
    //
    // Les deux écrans publics sont déclarés à plat, hors du layout : le
    // formateur n'a pas encore de session quand il les ouvre.
    {
      path: 'formateur/login',
      element: <FormateurLogin />
    },
    {
      path: 'formateur/invitation/:token',
      element: <FormateurInvitation />
    },
    {
      path: 'formateur',
      element: <FormateurLayout />,
      children: [
        {
          // `index: true` et non `path: ''` : la forme non ambiguë en Router v6
          // pour une route par défaut, qui ne doit se déclencher que sur
          // /formateur exactement, jamais sur un enfant.
          index: true,
          element: <Navigate to="/formateur/tableau-de-bord" replace />
        },
        {
          path: 'tableau-de-bord',
          element: <FormateurDashboard />
        },
        {
          path: 'sessions',
          element: <FormateurSessions />
        },
        {
          path: 'sessions/:id',
          element: <FormateurSessionDetail />
        },
        {
          path: 'planning',
          element: <FormateurPlanning />
        },
        {
          path: 'finances',
          element: <FormateurFinances />
        },
        {
          path: 'incidents',
          element: <FormateurIncidents />
        },
        {
          path: 'signalements',
          element: <FormateurSignalements />
        },
        {
          path: 'profil',
          element: <FormateurProfile />
        },
        {
          path: 'documents',
          element: <FormateurDocuments />
        },
        {
          path: 'competences',
          element: <FormateurCompetences />
        },
        {
          path: 'veille',
          element: <FormateurVeille />
        }
      ]
    },
    {
      path: 'blog',
      element: <BlogLayout />,
      children: [
        {
          path: '',
          element: <BlogPostList />
        },
        {
          path: 'new',
          element: <BlogPostCreate />
        },
        {
          path: ':postId',
          element: <BlogPostDetails />
        }
      ]
    },
    {
      path: 'contact',
      element: <Contact />
    },
    { path: 'formulaire', element: <Formulaire /> },
    {
      path: 'dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: '',
          element: <PermissionGuard perm="dashboard.view"><Finance /></PermissionGuard>
        },
        {
          path: 'account',
          element: <Account />
        },
        {
          path: 'analytics',
          element: <Analytics />
        },
        {
          path: 'calendar',
          element: <PermissionGuard perm="calendar.view"><Calendar /></PermissionGuard>
        },
        {
          path: 'presence',
          element: <Presence />
        },
        {
          path: 'logs',
          element: <PermissionGuard perm="logs.view"><Logs /></PermissionGuard>
        },
        {
          path: 'imports',
          element: <Imports />
        },
        {
          path: 'new-imports',
          element: <NewImport />
        },
        {
          path: 'csv-import',
          element: <CSVImportPage />
        },
        {
          path: 'email-notifications',
          element: <PermissionGuard perm="email_notifications.view"><Outlet /></PermissionGuard>,
          children: [
            {
              path: '',
              element: <EmailNotificationPage />
            },
            {
              path: 'new',
              element: <EmailTemplateCreate />
            },
            {
              path: 'scheduled',
              element: <ScheduledNotificationsPage />
            },
            {
              path: ':id/preview',
              element: <EmailNotificationPage />
            },
            {
              path: ':id/edit',
              element: <EmailNotificationPage />
            },
            {
              path: ':id',
              element: <EmailNotificationPage />
            }
          ]
        },
        {
          path: 'version-notes',
          children: [
            {
              path: '',
              element: <VersionNotesPage />
            },
            {
              path: ':id',
              element: <VersionNotesPage />
            }
          ]
        },
        {
          path: 'import-history',
          element: <ImportHistoryPage />
        },
        {
          path: 'campaign',
          element: <PermissionGuard perm="campaign.view"><Outlet /></PermissionGuard>,
          children: [
            {
              path: '',
              element: <Campagnes />,
            },
            {
              path: 'create',
              element: <CampaignCreate />,
            },
            {
              path: ':idCampaign',
              element: <CampaignInfo />,
            },
            {
              path: 'learner',
              element: <CampaignLearner />,
            },
            {
              path: ':campaignId/customer/:customerId',
              element: <CampaignCustomerDetails />
            },
            {
              path: ':campaignId/customer/:customerId/status/:status',
              element: <CampaignReinjectionCustomerDetails />
            },

          ] },
        {
          path: 'relaunch',
          element: <PermissionGuard perm="relaunch.view"><Outlet /></PermissionGuard>,
          children: [
            {
              path: '',
              element: <Reminders />,
            },
            {
              path: ':state/:endDateRelaunch',
              element: <RelaunchInfo />,
            },
            {
              path: ':state/:endDateRelaunch/customer/:customerId',
              element: <RelaunchCustomerDetails />
            },

          ]
        },
        {
          path: 'custom-reports',
          element: <PermissionGuard perm="custom_reports.view"><Outlet /></PermissionGuard>,
          children: [
            {
              path: '',
              element: <CustomReports />
            },
            {
              path: 'create',
              element: <CustomReportCreate />
            },
            {
              path: ':customReportId',
              element: <CustomReportDetails />
            },
            {
              path: 'edit/:customReportId',
              element: <CustomReportCreate />
            },
            {
              path: 'download/:customReportId',
              element: <CustomReportFullDetails />
            },
          ]
        },
        {
          path: 'shift',
          element: <PermissionGuard perm="shift.view"><Shift /></PermissionGuard>
        },
        {
          path: 'tickets',
          element: <PermissionGuard perm="tickets.view"><QualityPage type="ticket" /></PermissionGuard>
        },{
          path: 'complaint',
          element: <PermissionGuard perm="complaints.view"><QualityPage type="complaint" /></PermissionGuard>
        },{
          path: 'qualiopi',
          element: <PermissionGuard perm="qualiopi.view"><Qualiopi /></PermissionGuard>
        },
         {
          path: 'satisfactions',
          element: <FormationsSatisfaction />
        },
        {
          path: 'performances',
          element: <FormationsPerformance />
        },
        {
          path: 'questionnaire-formation',
          element: <PermissionGuard perm="questionnaires.view"><QuestionnaireFormation /></PermissionGuard>
        },
        {
          path: 'questionnaire-formation/:id',
          element: <PermissionGuard perm="questionnaires.view"><QuestionnaireDetails /></PermissionGuard>
        },
        {
          path: 'questionnaire-satisfaction',
          element: <QuestionnaireSatisfaction /> // menu seulement : l'onglet « Suivi des réponses » d'une session y renvoie
        },
        {
          // Même écran, autre audience : les réponses des formateurs. Page à
          // part parce qu'une session n'a qu'un formateur — il n'y a rien à
          // regrouper par session — mais présentée comme un onglet de plus.
          path: 'questionnaire-formateurs',
          element: <QuestionnaireFormateurs />
        },
        {
          // Le compte rendu Word est porté par la session et couvre les trois
          // types : il a sa page plutôt qu'un onglet de plus.
          path: 'comptes-rendus',
          element: <ComptesRendus />
        },
        {
          path: 'plan-action/:formationId',
          element: <ActionPlanFormation />
        },
        {
          // Lecture transversale des plans d'action : ce qui reste à clôturer,
          // toutes formations confondues.
          path: 'plans-action-ouverts',
          element: <ActionPlansOuverts />
        },
        {
          path: 'questionnaire-progression',
          element: <QuestionnaireProgression />
        },
        {
          path: 'visualisation-globale',
          element: <VisualisationGlobale />
        },
        {
          path: 'chat',
          children: [
            {
              path: '',
              element: <Chat />
            },
            {
              path: 'new',
              element: <Chat />
            },
            {
              path: ':threadKey',
              element: <Chat />
            }
          ]
        },
        {
          path: 'customers',
          element: <PermissionGuard perm="customers.view"><Outlet /></PermissionGuard>,
          children: [
            {
              path: '',
              element: <CustomerList />
            },
            {
              path: ':customerId',
              element: <CustomerDetails />
            },
            {
              path: 'create',
              element: <CustomerCreate />
            },
          ]
        },
        {
          path: 'intervenants',
          element: <PermissionGuard perm="intervenants.view"><Outlet /></PermissionGuard>,
          children: [
            {
              path: '',
              element: <Intervenants />
            },
            {
              path: ':intervenantId',
              element: <IntervenantDetails />
            },
          ]
        },
        {
          path: 'lieux-formation',
          element: <PermissionGuard perm="lieux.view"><Outlet /></PermissionGuard>,
          children: [
            {
              path: '',
              element: <LieuxFormation />
            },
            {
              path: ':id',
              element: <LieuFiche />
            }
          ]
        },
        {
          path: 'prospects',
          element: <PermissionGuard perm="prospects.view"><Outlet /></PermissionGuard>,
          children: [
            {
              path: '',
              element: <CustomerNewProspects />
            },
          ]
        },
        {
          path: 'partners',
          element: <PermissionGuard perm="partners.view"><Partners /></PermissionGuard>
        },
        {
          path: 'customercreate',
          children: [
            {
              path: ':customerId',
              element: <CustomerDetails />
            },
          ]
        },
        // {
        //   path: 'customerrecall',
        //   children: [
        //     {
        //       path: ':customerId',
        //       element: <CustomerDetails />
        //     },
        //   ]
        // },
        // {
        //   path: 'customersession',
        //   children: [
        //     {
        //       path: ':customerId',
        //       element: <CustomerDetails />
        //     },
        //   ]
        // },
        {
          path: 'invoices',
          children: [
            {
              path: '',
              element: <InvoiceList />
            },
            {
              path: ':invoiceId',
              element: <InvoiceDetails />
            }
          ]
        },
        {
          path: 'kanban',
          element: <Kanban />
        },
        {
          path: 'mail',
          children: [
            {
              path: '',
              element: (
                <Navigate
                  to="/dashboard/mail/all"
                  replace
                />
              )
            },
            {
              path: 'label/:customLabel',
              element: <Mail />
            },
            {
              path: 'label/:customLabel/:emailId',
              element: <Mail />
            },
            {
              path: ':systemLabel',
              element: <Mail />
            },
            {
              path: ':systemLabel/:emailId',
              element: <Mail />
            }
          ]
        },
        {
          path: 'orders',
          children: [
            {
              path: '',
              element: <OrderList />
            },
            {
              path: ':orderId',
              element: <OrderDetails />
            }
          ]
        },
        {
          path: 'formations',
          element: <PermissionGuard perm="formations.view"><Outlet /></PermissionGuard>,
          children: [
            {
              path: '',
              element: <Formations />
            },
            {
              path: ':formationId',
              element: <FormationDetails />
            },
            {
              path: 'create',
              element: <FormationCreate />
            }
          ]
        },
        {
          path: 'formationSession',
          element: <PermissionGuard perm="sessions.view"><Outlet /></PermissionGuard>,
          children: [
            {
              path: '',
              element: <SessionFormationList />
            },
          ]
        },
        {
          path: 'rh',
          children: [
            {
              path: 'collaborateurs',
              element: <PermissionGuard perm="rh.view"><RhCollaborateurs /></PermissionGuard>
            },
            {
              path: 'collaborateurs/:userId',
              element: <PermissionGuard perm="rh.view"><RhCollaborateurFiche /></PermissionGuard>
            },
            {
              path: 'conges',
              element: <PermissionGuard perm="rh_conges.view"><RhConges /></PermissionGuard>
            },
            {
              path: 'pointage',
              element: <PermissionGuard perm="rh_pointage.view"><RhPointage /></PermissionGuard>
            },
            {
              path: 'entretiens',
              element: <PermissionGuard perm="rh_entretiens.view"><RhEntretiens /></PermissionGuard>
            },
            {
              path: 'formation',
              element: <PermissionGuard perm="rh_formation.view"><RhFormation /></PermissionGuard>
            },
            {
              path: 'sante',
              element: <PermissionGuard perm="rh_sante.view"><RhSante /></PermissionGuard>
            },
            {
              path: 'handicap',
              element: <PermissionGuard perm="rh_handicap.view"><RhHandicap /></PermissionGuard>
            },
            {
              path: 'duerp',
              element: <PermissionGuard perm="rh_duerp.view"><RhDuerp /></PermissionGuard>
            },
            {
              // `index: true` : le tableau de bord répond sur /dashboard/rh
              // exactement, jamais à la place d'un de ses enfants.
              index: true,
              element: <PermissionGuard perm="rh_dashboard.view"><RhDashboard /></PermissionGuard>
            },
            {
              path: 'conformite',
              element: <PermissionGuard perm="rh_conformite.view"><RhConformite /></PermissionGuard>
            },
            {
              path: 'parametres',
              element: <PermissionGuard perm="rh_parametres.view"><RhParametres /></PermissionGuard>
            },
            {
              path: 'recrutement',
              element: <PermissionGuard perm="rh_recrutement.view"><RhRecrutement /></PermissionGuard>
            },
            {
              path: 'onboarding',
              element: <PermissionGuard perm="rh_onboarding.view"><RhOnboarding /></PermissionGuard>
            }
          ]
        },
        {
          path: 'academie',
          element: (
            <PermissionGuard perm="academie.view">
              <Academie />
            </PermissionGuard>
          )
        },
        {
          path: 'tasks-tracking',
          element: (
            <PermissionGuard perm="tasks_tracking.view" fallback={legacyTaskTracking}>
              <TasksTracking />
            </PermissionGuard>
          )
        },
        {
          path: 'mails-tracking',
          element: (
            <PermissionGuard perm="mails_tracking.view">
              <MailsTracking />
            </PermissionGuard>
          )
        },
        {
          path: 'learners-tracking',
          element: (
            <PermissionGuard perm="learners_tracking.view" fallback={legacyTaskTracking}>
              <LearnersTracking />
            </PermissionGuard>
          )
        },
        {
          path: 'reports-cancellations-tracking',
          element: (
            <PermissionGuard perm="reports_cancellations.view" fallback={legacyTaskTracking}>
              <ReportsAndCancellationsTracking />
            </PermissionGuard>
          )
        },
        {
          path: 'products',
          children: [
            {
              path: '',
              element: <ProductList />
            },
            {
              path: 'new',
              element: <ProductCreate />
            }
          ]
        },
        {
          path: 'projects',
          children: [
            {
              path: 'browse',
              element: <ProjectBrowse />
            },
            {
              path: 'new',
              element: <ProjectCreate />
            },
            {
              path: ':projectId',
              element: <ProjectDetails />
            }
          ]
        },
        {
          path: 'etablissements',
          children: [
            {
              // Garde sur la liste seulement : la fiche Apprenant (Commercial,
              // Suivi) renvoie vers les fiches établissement.
              path: '',
              element: <PermissionGuard perm="etablissements.view"><EtablissementList /></PermissionGuard>
            },
            {
              path: ':etablissementID',
              element: <EtablissementDetails />
            },
            {
              path: 'create',
              element: <EtablissementCreate />
            },
            {
              path: ':edit',
              element: <EtablissementEdit />
            }
          ]
        },
        {
          path: 'session',
          element: <PermissionGuard perm="sessions.view"><Outlet /></PermissionGuard>,
          children: [
            {
              path: ':sessionID',
              element: <SessionDetails />
            },
            {
              path: 'create/:idFormation',
              element: <SessionCreate />
            },
            // {
            //   path: ':edit',
            //   element: <SessionEdit />
            // },
            {
              path: 'creatCustomer',
              element: <SessionCreatCustomer />
            },
            {
              path: 'sessionStats',
              element: <SessionStats />
            }
          ]
        },
        {
          path: 'email-settings',
          children: [
            {
              path: '',
              element: <EmailSettings />
            },
           
          ]
        },

        {
          path: 'groupements',
          children: [
            {
              path: '',
              element: <GroupementList />
            },
            {
              path: ':groupementID',
              element: <GroupementDetails />
            },
            {
              path: 'create',
              element: <GroupementCreate />
            },
            {
              path: ':edit',
              element: <GroupementEdit />
            }
          ]
        },
        {
          path: 'campagne',
          children: [
            {
              path: '',
              element: <CustomerList />
            },
            {
              path: ':customerId',
              element: <CustomerDetails />
            },
          ]
        },

        {
          path: 'users',
          element: <PermissionGuard perm="users.view"><Outlet /></PermissionGuard>,
          children: [
            {
              path: '',
              element: <UsersList />
            },
          // {
          //   path: ':customerId',
          //   element: <CustomerDetails />
          // },
          ]
        },
        {
          path: 'roles',
          element: <PermissionGuard perm="roles.view" fallback={legacyAdminOnly}><RolesPermissions /></PermissionGuard>
        },
        {
          path: 'user',
          children: [
          // {
          //   path: '/',
          //   element: <UsersList />
          // },
            {
              path: ':userId',
              element: <AccountAdmin />
            },
          ]
        },
        {
          path: 'analysis',
          element: <PermissionGuard perm="analysis.view"><Outlet /></PermissionGuard>,
          children: [
            {
              path: '',
              element: <Analysis />
            },
          // {
          //   path: ':customerId',
          //   element: <CustomerDetails />
          // },
          ]
        },
        {
          path: 'social',
          children: [
            {
              path: 'feed',
              element: <SocialFeed />
            },
            {
              path: 'profile',
              element: <SocialProfile />
            }
          ]
        }
      ]
    },
    {
      path: 'docs',
      element: <DocsLayout />,
      children: [
        {
          path: '',
          element: (
            <Navigate
              to="/docs/overview/welcome"
              replace
            />
          )
        },
        {
          path: '*',
          element: <Docs />
        }
      ]
    },
    {
      path: '*',
      element: <MainLayout />,
      children: [
        {
          path: '',
          element: <Home />
        },
        {
          path: 'checkout',
          element: <Checkout />
        },
        {
          path: 'pricing',
          element: <Pricing />
        },
        {
          path: '401',
          element: <AuthorizationRequired />
        },
        {
          path: '404',
          element: <NotFound />
        },
        {
          path: '500',
          element: <ServerError />
        },
        {
          path: '*',
          element: <NotFound />
        }
      ]
    }
  ];

  return useRoutes(routes);
};
export default AppRoutes;
